import { AfterViewInit, Directive, ElementRef, OnDestroy, Renderer2, inject } from '@angular/core';

@Directive({
    selector: '[appTitleProvider]',
    standalone: false
})
export class TitleProviderDirective implements AfterViewInit, OnDestroy{
    private readonly el = inject(ElementRef);
    private readonly renderer = inject(Renderer2);


    private mutationObserver: MutationObserver;

    ngAfterViewInit() {
        this.mutationObserver = new MutationObserver( () => {
            this.provideTitle();
        });

        this.mutationObserver.observe(this.el.nativeElement, {
            characterData: true,
            childList: false,
            subtree: true
        });

        this.provideTitle();
    }

    ngOnDestroy() {
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
        }
    }

    private provideTitle(): void {
        const element: HTMLElement = this.el.nativeElement;
        const text = element.innerText || element.textContent;

        this.renderer.setAttribute(element, 'title', text.trim());
    }

}
